'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styleSelector = exports.localeSelector = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = wixStylesSaga;

var _effects = require('redux-saga/effects');

var _WebInitActions = require('../actions/WebInitActions');

var WebInitActions = _interopRequireWildcard(_WebInitActions);

var _OrganizationActions = require('../actions/OrganizationActions');

var OrganizationActions = _interopRequireWildcard(_OrganizationActions);

var _I18nActions = require('../actions/I18nActions');

var I18nActions = _interopRequireWildcard(_I18nActions);

var _WixStylesColorUtils = require('@wix/wixrest-utils/dist/WixStylesColorUtils');

var _WixStylesColorUtils2 = _interopRequireDefault(_WixStylesColorUtils);

var _WixStylesFontUtils = require('@wix/wixrest-utils/dist/WixStylesFontUtils');

var _WixStylesFontUtils2 = _interopRequireDefault(_WixStylesFontUtils);

var _WixStylesNumberUtils = require('@wix/wixrest-utils/dist/WixStylesNumberUtils');

var _WixStylesNumberUtils2 = _interopRequireDefault(_WixStylesNumberUtils);

var _WixStylesBoolUtils = require('@wix/wixrest-utils/dist/WixStylesBoolUtils');

var _WixStylesBoolUtils2 = _interopRequireDefault(_WixStylesBoolUtils);

var _StylesActions = require('../actions/StylesActions');

var StylesActions = _interopRequireWildcard(_StylesActions);

var _WixBridgeSaga = require('./WixBridgeSaga');

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _lzutf = require('lzutf8');

var _lzutf2 = _interopRequireDefault(_lzutf);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(initializeUsingWix),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(wixStylesSaga);

var sagas = [];
function handle(EVENT, target) {
    sagas.push( /*#__PURE__*/_regenerator2.default.mark(function _callee(sagaParams) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _effects.takeEvery)(EVENT, target.bind(null, sagaParams));

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));
}

// ============================================================================
// ACTION HANDLERS
// ============================================================================
var _enabled = true;
var _initialized = false;

handle(WebInitActions.types.INIT_WEB, /*#__PURE__*/_regenerator2.default.mark(function _callee4(sagaParams, action) {
    var payload, type;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    payload = action.payload;
                    type = payload.type;

                    _enabled = !(type === 'wix-menus-facebook' || type === 'dashboard');

                    /*
                     * Things TODO
                     *
                     * 1. if ((type === 'wix-menus-facebook') || (type === 'livemap')), run default data
                     * 2. standalone mode
                     * 4. Actions:
                     *      onSetWixMenuLayout(actionParams) { var layout = actionParams.layout;
                     *      onSetWidget(actionParams) { var key = actionParams.widget; var value = actionParams.value;
                     *      onSetWixOrdersLayout(actionParams) {
                     *      onResetColors()
                     *      onResetFonts() {
                     *      onSetPublicData(actionParams = {}) { ???
                    */

                    return _context4.delegateYield(initializeUsingWix(sagaParams), 't0', 4);

                case 4:
                    if (!_enabled) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 7;
                    return (0, _effects.spawn)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                        var channel;
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        _context2.next = 2;
                                        return (0, _effects.call)(_WixBridgeSaga.listenToWixEvent, sagaParams.Wix.Events.STYLE_PARAMS_CHANGE, sagaParams.Wix);

                                    case 2:
                                        channel = _context2.sent;
                                        _context2.next = 5;
                                        return (0, _effects.takeEvery)(channel, initializeUsingWix.bind(null, sagaParams));

                                    case 5:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, this);
                    }));

                case 7:
                    _context4.next = 9;
                    return (0, _effects.spawn)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                        var channel;
                        return _regenerator2.default.wrap(function _callee3$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        _context3.next = 2;
                                        return (0, _effects.call)(_WixBridgeSaga.listenToWixEvent, sagaParams.Wix.Events.SETTINGS_UPDATED, sagaParams.Wix);

                                    case 2:
                                        channel = _context3.sent;
                                        _context3.next = 5;
                                        return (0, _effects.takeEvery)(channel, initializeUsingWix.bind(null, sagaParams));

                                    case 5:
                                    case 'end':
                                        return _context3.stop();
                                }
                            }
                        }, _callee3, this);
                    }));

                case 9:

                    _initialized = true;

                    /*
                    const styleData = window.styles;
                     yield put(StylesActions.actions.setStyles({styles:styleData}));
                    */

                    // TODO: standalone

                case 10:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _callee4, this);
}));

handle(OrganizationActions.types.ORGANIZATION_LOAD, /*#__PURE__*/_regenerator2.default.mark(function _callee5(sagaParams) {
    return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (_initialized) {
                        _context5.next = 2;
                        break;
                    }

                    return _context5.abrupt('return');

                case 2:
                    return _context5.delegateYield(initializeUsingWix(sagaParams), 't0', 3);

                case 3:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _callee5, this);
}));

handle(I18nActions.types.I18N_INIT, /*#__PURE__*/_regenerator2.default.mark(function _callee6(sagaParams) {
    return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (_initialized) {
                        _context6.next = 2;
                        break;
                    }

                    return _context6.abrupt('return');

                case 2:
                    return _context6.delegateYield(initializeUsingWix(sagaParams), 't0', 3);

                case 3:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _callee6, this);
}));

handle(I18nActions.types.I18N_VIEW_READY_FOR_CHANGE, /*#__PURE__*/_regenerator2.default.mark(function _callee7(sagaParams) {
    var Wix;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    if (_initialized) {
                        _context7.next = 2;
                        break;
                    }

                    return _context7.abrupt('return');

                case 2:
                    Wix = sagaParams.Wix;

                    if (!(Wix && !Wix.Utils.getOrigCompId())) {
                        _context7.next = 5;
                        break;
                    }

                    return _context7.delegateYield(initializeUsingWix(sagaParams), 't0', 5);

                case 5:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _callee7, this);
}));

handle(StylesActions.types.SET_STYLE_NUMBER, /*#__PURE__*/_regenerator2.default.mark(function _callee8(sagaParams, action) {
    var Wix, _action$payload, payload, name, value, styles;

    return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload = action.payload, payload = _action$payload === undefined ? {} : _action$payload;
                    name = payload.name, value = payload.value;


                    Wix.Styles.setNumberParam(name, { value: value });

                    _context8.t0 = _lodash2.default;
                    _context8.next = 7;
                    return (0, _effects.select)(styleSelector);

                case 7:
                    _context8.t1 = _context8.sent;
                    styles = _context8.t0.cloneDeep.call(_context8.t0, _context8.t1);

                    styles.numbers[name] = value;
                    _context8.next = 12;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 12:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _callee8, this);
}));

handle(StylesActions.types.BULK_SET_STYLE_NUMBER, /*#__PURE__*/_regenerator2.default.mark(function _callee9(sagaParams, action) {
    var Wix, _action$payload2, payload, values, updateUI, styles, numbers, _loop, i;

    return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload2 = action.payload, payload = _action$payload2 === undefined ? [] : _action$payload2;
                    values = payload.values;
                    updateUI = payload.updateUI === true;
                    _context9.t0 = _lodash2.default;
                    _context9.next = 7;
                    return (0, _effects.select)(styleSelector);

                case 7:
                    _context9.t1 = _context9.sent;
                    styles = _context9.t0.cloneDeep.call(_context9.t0, _context9.t1);
                    numbers = [];

                    _loop = function _loop(i) {
                        var number = values[i];
                        numbers.push((0, _effects.call)([Wix.Styles, Wix.Styles.setNumberParam], number.name, { value: number.value }, function () {
                            if (updateUI) {
                                Wix.Styles.setUILIBParamValue('numbers', number.name, { value: number.value });
                            }
                        }));
                        styles.numbers[number.name] = number.value;
                    };

                    for (i = 0; i < values.length; i++) {
                        _loop(i);
                    }

                    _context9.next = 14;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 14:
                    _context9.next = 16;
                    return numbers;

                case 16:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _callee9, this);
}));

handle(StylesActions.types.SET_STYLE_COLOR, /*#__PURE__*/_regenerator2.default.mark(function _callee10(sagaParams, action) {
    var Wix, _action$payload3, payload, name, value, updateUI, origStyles, realValue, rgba, styles;

    return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.prev = 0;
                    Wix = sagaParams.Wix;
                    _action$payload3 = action.payload, payload = _action$payload3 === undefined ? {} : _action$payload3;
                    name = payload.name, value = payload.value, updateUI = payload.updateUI;
                    _context10.next = 6;
                    return (0, _effects.select)(styleSelector);

                case 6:
                    origStyles = _context10.sent;
                    realValue = value.startsWith('color-') && origStyles.colors.hasOwnProperty(value) ? origStyles.colors[value] : value;
                    rgba = new _color2.default(realValue).rgbaString();


                    Wix.Styles.setColorParam(name, { value: { rgba: rgba } }, function () {
                        if (updateUI) {
                            Wix.Styles.setUILIBParamValue('colors', name, { rgba: rgba });
                        }
                    });

                    styles = _lodash2.default.cloneDeep(origStyles);

                    styles.colors[name] = rgba;
                    _context10.next = 14;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 14:
                    _context10.next = 18;
                    break;

                case 16:
                    _context10.prev = 16;
                    _context10.t0 = _context10['catch'](0);

                case 18:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _callee10, this, [[0, 16]]);
}));

handle(StylesActions.types.BULK_SET_STYLE_COLOR, /*#__PURE__*/_regenerator2.default.mark(function _callee11(sagaParams, action) {
    var Wix, _action$payload4, payload, values, updateUI, originalStyles, hasValues, styles, colors, _loop2, i;

    return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload4 = action.payload, payload = _action$payload4 === undefined ? [] : _action$payload4;
                    values = payload.values, updateUI = payload.updateUI;
                    _context11.next = 5;
                    return (0, _effects.select)(styleSelector);

                case 5:
                    originalStyles = _context11.sent;
                    hasValues = values.length > 0;
                    styles = hasValues ? _lodash2.default.cloneDeep(originalStyles) : originalStyles;
                    colors = [];

                    _loop2 = function _loop2(i) {
                        var _values$i = values[i],
                            name = _values$i.name,
                            value = _values$i.value;

                        var realValue = value.startsWith('color-') && styles.colors.hasOwnProperty(value) ? styles.colors[value] : value;
                        var rgba = new _color2.default(realValue).rgbaString();
                        colors.push((0, _effects.call)([Wix.Styles, Wix.Styles.setColorParam], name, { value: { rgba: rgba } }, function () {
                            if (updateUI) {
                                Wix.Styles.setUILIBParamValue('colors', name, { rgba: rgba });
                            }
                        }));
                        styles.colors[name] = rgba;
                    };

                    for (i = 0; i < values.length; i++) {
                        _loop2(i);
                    }

                    if (!hasValues) {
                        _context11.next = 16;
                        break;
                    }

                    _context11.next = 14;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 14:
                    _context11.next = 16;
                    return colors;

                case 16:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _callee11, this);
}));

handle(StylesActions.types.SET_STYLE_FONT, /*#__PURE__*/_regenerator2.default.mark(function _callee12(sagaParams, action) {
    var Wix, _action$payload5, payload, _name, value, updateUI, origStyles, styles;

    return _regenerator2.default.wrap(function _callee12$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.prev = 0;
                    Wix = sagaParams.Wix;
                    _action$payload5 = action.payload, payload = _action$payload5 === undefined ? {} : _action$payload5;
                    _name = payload.name, value = payload.value, updateUI = payload.updateUI;
                    _context12.next = 6;
                    return (0, _effects.select)(styleSelector);

                case 6:
                    origStyles = _context12.sent;


                    Wix.Styles.setFontParam(_name, { value: value }, function () {
                        var fontValue = origStyles.fonts[_name];
                        if (updateUI) {
                            Wix.Styles.setUILIBParamValue('fonts', _name, fontValue);
                        }
                    });

                    styles = _lodash2.default.cloneDeep(origStyles);

                    styles.fonts[_name] = { value: value };
                    _context12.next = 12;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 12:
                    _context12.next = 16;
                    break;

                case 14:
                    _context12.prev = 14;
                    _context12.t0 = _context12['catch'](0);

                case 16:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _callee12, this, [[0, 14]]);
}));

handle(StylesActions.types.BULK_SET_STYLE_FONT, /*#__PURE__*/_regenerator2.default.mark(function _callee13(sagaParams, action) {
    var Wix, _action$payload6, payload, values, updateUI, originalStyles, hasValues, styles, fonts, _loop3, i;

    return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload6 = action.payload, payload = _action$payload6 === undefined ? [] : _action$payload6;
                    values = payload.values, updateUI = payload.updateUI;
                    _context13.next = 5;
                    return (0, _effects.select)(styleSelector);

                case 5:
                    originalStyles = _context13.sent;
                    hasValues = values.length > 0;
                    styles = hasValues ? _lodash2.default.cloneDeep(originalStyles) : originalStyles;
                    fonts = [];

                    _loop3 = function _loop3(i) {
                        var _values$i2 = values[i],
                            name = _values$i2.name,
                            value = _values$i2.value;

                        var fontValue = styles.fonts[value] || value;
                        fonts.push((0, _effects.call)([Wix.Styles, Wix.Styles.setFontParam], name, { value: fontValue }, function () {
                            if (updateUI) {
                                Wix.Styles.setUILIBParamValue('fonts', name, fontValue);
                            }
                        }));
                        styles.fonts[name] = fontValue;
                    };

                    for (i = 0; i < values.length; i++) {
                        _loop3(i);
                    }

                    if (!hasValues) {
                        _context13.next = 16;
                        break;
                    }

                    _context13.next = 14;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 14:
                    _context13.next = 16;
                    return fonts;

                case 16:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _callee13, this);
}));

handle(StylesActions.types.SET_STYLE_BOOLEAN, /*#__PURE__*/_regenerator2.default.mark(function _callee14(sagaParams, action) {
    var Wix, _action$payload7, payload, name, value, styles;

    return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload7 = action.payload, payload = _action$payload7 === undefined ? {} : _action$payload7;
                    name = payload.name, value = payload.value;


                    Wix.Styles.setBooleanParam(name, { value: value });

                    _context14.t0 = _lodash2.default;
                    _context14.next = 7;
                    return (0, _effects.select)(styleSelector);

                case 7:
                    _context14.t1 = _context14.sent;
                    styles = _context14.t0.cloneDeep.call(_context14.t0, _context14.t1);

                    styles.booleans[name] = value;
                    _context14.next = 12;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 12:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _callee14, this);
}));

handle(StylesActions.types.BULK_SET_STYLE_MIXED, /*#__PURE__*/_regenerator2.default.mark(function _callee15(sagaParams, action) {
    var Wix, payload, styles, actions, key, list, i, style;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    payload = action.payload;
                    _context15.t0 = _lodash2.default;
                    _context15.next = 5;
                    return (0, _effects.select)(styleSelector);

                case 5:
                    _context15.t1 = _context15.sent;
                    styles = _context15.t0.cloneDeep.call(_context15.t0, _context15.t1);
                    actions = [];
                    _context15.t2 = _regenerator2.default.keys(payload);

                case 9:
                    if ((_context15.t3 = _context15.t2()).done) {
                        _context15.next = 30;
                        break;
                    }

                    key = _context15.t3.value;

                    if (!(payload.hasOwnProperty(key) && payload[key])) {
                        _context15.next = 28;
                        break;
                    }

                    list = payload[key];
                    i = 0;

                case 14:
                    if (!(i < list.length)) {
                        _context15.next = 28;
                        break;
                    }

                    style = list[i];
                    _context15.t4 = key;
                    _context15.next = _context15.t4 === 'numbers' ? 19 : _context15.t4 === 'booleans' ? 22 : 25;
                    break;

                case 19:
                    actions.push((0, _effects.call)([Wix.Styles, Wix.Styles.setNumberParam], style.name, { value: style.value }));
                    styles.numbers[style.name] = style.value;
                    return _context15.abrupt('break', 25);

                case 22:
                    actions.push((0, _effects.call)([Wix.Styles, Wix.Styles.setBooleanParam], style.name, { value: style.value }));
                    styles.booleans[style.name] = style.value;
                    return _context15.abrupt('break', 25);

                case 25:
                    i++;
                    _context15.next = 14;
                    break;

                case 28:
                    _context15.next = 9;
                    break;

                case 30:
                    _context15.next = 32;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 32:
                    _context15.next = 34;
                    return actions;

                case 34:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _callee15, this);
}));

handle(StylesActions.types.SET_STYLE_DATA, /*#__PURE__*/_regenerator2.default.mark(function _callee16(sagaParams, action) {
    var Wix, _action$payload8, payload, name, value, compressedValue, styles;

    return _regenerator2.default.wrap(function _callee16$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _action$payload8 = action.payload, payload = _action$payload8 === undefined ? {} : _action$payload8;
                    name = payload.name, value = payload.value;
                    compressedValue = _lzutf2.default.compress((0, _stringify2.default)(value), { outputEncoding: 'Base64' });


                    Wix.Data.Public.set(name, compressedValue, { scope: 'COMPONENT' }, function (result) {
                        console.log('[WixStylesSaga.setStyleData] >> Success', result);
                    }, function (err) {
                        console.error('[WixStylesSaga.setStyleData] >> Error', err);
                    });

                    _context16.t0 = _lodash2.default;
                    _context16.next = 8;
                    return (0, _effects.select)(styleSelector);

                case 8:
                    _context16.t1 = _context16.sent;
                    styles = _context16.t0.cloneDeep.call(_context16.t0, _context16.t1);

                    styles.data[name] = value;
                    _context16.next = 13;
                    return (0, _effects.put)(StylesActions.actions.setStyles({ styles: styles }));

                case 13:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _callee16, this);
}));

handle(StylesActions.types.RESET_COLORS_AND_FONTS, /*#__PURE__*/_regenerator2.default.mark(function _callee17(sagaParams) {
    var Wix, styleParams, promises;
    return _regenerator2.default.wrap(function _callee17$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    Wix = sagaParams.Wix;
                    _context17.next = 3;
                    return (0, _effects.call)(function () {
                        var deferred = _q2.default.defer();

                        Wix.Styles.getStyleParams(function (res) {
                            return res ? deferred.resolve(res) : deferred.reject();
                        });

                        return deferred.promise;
                    });

                case 3:
                    styleParams = _context17.sent;
                    promises = [];


                    _lodash2.default.each(styleParams.colors, function (v, k) {
                        promises.push(function () {
                            var deferred = _q2.default.defer();
                            Wix.Styles.setColorParam(k, { value: { rgba: 'rgba(1,2,3,1)' } }, function () {
                                Wix.Styles.setUILIBParamValue('colors', k, { rgba: 'rgba(1,2,3,1)' });
                                return deferred.resolve();
                            });
                            return deferred.promise;
                        }());
                    });

                    _lodash2.default.each(styleParams.fonts, function (v, k) {
                        promises.push(function () {
                            var deferred = _q2.default.defer();
                            Wix.Styles.setFontParam(k, {}, function () {
                                Wix.Styles.setUILIBParamValue('fonts', k, null);
                                return deferred.resolve();
                            });
                            return deferred.promise;
                        }());
                    });

                    _context17.next = 9;
                    return (0, _effects.call)(function () {
                        return _q2.default.all(promises);
                    });

                case 9:
                    return _context17.delegateYield(initializeUsingWix(sagaParams), 't0', 10);

                case 10:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _callee17, this);
}));

// ============================================================================
// PRIVATE HELPER METHODS
// ============================================================================

function initializeUsingWix(sagaParams) {
    var Wix, wss, window, type, siteColors, siteTextPresets, styleParams, _ref, _ref2, _ref3, _ref4, locale, compId, colorStyles, fontStyles, numberStyles, boolStyles, googleFontsCssUrl, forceArial, colors, fonts, numbers, booleans, upgrade, full, organization, data, getSetter, currentStyles, newStyles;

    return _regenerator2.default.wrap(function initializeUsingWix$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    Wix = sagaParams.Wix, wss = sagaParams.wss, window = sagaParams.window, type = sagaParams.type;
                    siteColors = void 0, siteTextPresets = void 0, styleParams = void 0;

                    if (_enabled) {
                        _context18.next = 8;
                        break;
                    }

                    siteColors = DISABLED_STYLES_CONSTS.siteColors;
                    siteTextPresets = DISABLED_STYLES_CONSTS.siteTextPresets;
                    styleParams = DISABLED_STYLES_CONSTS.styleParams;

                    _context18.next = 28;
                    break;

                case 8:
                    if (!(Wix.Utils.getViewMode() === 'standalone' || !Wix.Utils.getViewMode())) {
                        _context18.next = 21;
                        break;
                    }

                    if (window.remoteStyles) {
                        siteColors = window.remoteStyles.siteColors;
                        siteTextPresets = window.remoteStyles.siteTextPresets;
                        styleParams = window.remoteStyles.styleParams;
                    };

                    // This happens in editor mode, before initial save, when previewing mobile

                    if (!(_lodash2.default.isEmpty((styleParams || {}).colors) && Wix.Utils.getDeviceType() === 'mobile')) {
                        _context18.next = 19;
                        break;
                    }

                    _context18.next = 14;
                    return (0, _effects.call)(function () {

                        var deferred = _q2.default.defer();

                        window.wixrestaurantsordersnativemobilegetstyleparamsresponse = function (value) {
                            deferred.resolve(value);
                            deferred = null;
                        };

                        window.parent.postMessage('wixrestaurantsordersnativemobilegetstyleparams', window.location.href);

                        setTimeout(function () {
                            if (deferred !== null) {
                                deferred.resolve([siteColors, siteTextPresets, styleParams]);
                                deferred = null;
                            }
                        }, 3000);

                        return deferred.promise;
                    });

                case 14:
                    _ref = _context18.sent;
                    _ref2 = (0, _slicedToArray3.default)(_ref, 3);
                    siteColors = _ref2[0];
                    siteTextPresets = _ref2[1];
                    styleParams = _ref2[2];

                case 19:
                    _context18.next = 28;
                    break;

                case 21:
                    _context18.next = 23;
                    return (0, _effects.all)([(0, _effects.call)(function () {
                        var deferred = _q2.default.defer();

                        Wix.Styles.getSiteColors(function (res) {
                            return res ? deferred.resolve(res) : deferred.reject();
                        });

                        return deferred.promise;
                    }), (0, _effects.call)(function () {
                        var deferred = _q2.default.defer();

                        Wix.Styles.getSiteTextPresets(function (res) {
                            return res ? deferred.resolve(res) : deferred.reject();
                        });

                        return deferred.promise;
                    }), (0, _effects.call)(function () {
                        var deferred = _q2.default.defer();

                        Wix.Styles.getStyleParams(function (res) {
                            return res ? deferred.resolve(res) : deferred.reject();
                        });

                        return deferred.promise;
                    })]);

                case 23:
                    _ref3 = _context18.sent;
                    _ref4 = (0, _slicedToArray3.default)(_ref3, 3);
                    siteColors = _ref4[0];
                    siteTextPresets = _ref4[1];
                    styleParams = _ref4[2];

                case 28:
                    _context18.next = 30;
                    return (0, _effects.select)(localeSelector);

                case 30:
                    locale = _context18.sent;
                    compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId();
                    colorStyles = _lodash2.default.omitBy(styleParams.colors || {}, function (v) {
                        return _lodash2.default.isEqual(v, { value: "rgba(1,2,3,1)" }) || _lodash2.default.isEqual(v, { rgba: 'rgba(1,2,3,1)' });
                    });
                    fontStyles = _lodash2.default.omitBy(styleParams.fonts || {}, function (v) {
                        return !v;
                    });
                    numberStyles = styleParams.numbers || {};
                    boolStyles = styleParams.booleans || {};
                    googleFontsCssUrl = styleParams.googleFontsCssUrl;
                    forceArial = type !== 'wixmenus.client' && type !== 'restaurants-portal';
                    colors = _WixStylesColorUtils2.default.getFullColorStyles({ colorStyles: colorStyles, siteColors: siteColors, defaults: wss.defaults.colors });
                    fonts = _WixStylesFontUtils2.default.getFullFontStyles({ fontStyles: fontStyles, siteTextPresets: siteTextPresets, defaults: wss.defaults.fonts, isHebrew: locale === 'he_IL', forceArial: forceArial });
                    numbers = _WixStylesNumberUtils2.default.getFullNumberStyles({ numberStyles: numberStyles });
                    booleans = _WixStylesBoolUtils2.default.getFullBoolStyles({ boolStyles: boolStyles, compId: Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() });

                    // The following code is the slow upgrade of the new menu settings screen

                    upgrade = false;
                    full = window.full || {};
                    organization = full.restaurant || full.chain;

                    // Stage one - only 1/16 of the users received it

                    if (window.WixInstance && window.WixInstance.getSiteOwnerId()) {
                        if (window.WixInstance.getSiteOwnerId().split('').pop() === '6') {

                            if (!organization) {
                                upgrade = true;
                            } else {
                                upgrade = !window.full || !window.fullFromSite || organization.created > 1464700000000;
                            }

                            // Stage two - 1/4 of the users received it
                        } else if (parseInt(window.WixInstance.getSiteOwnerId().split('').pop(), 16) < 8) {

                            if (!organization) {
                                upgrade = true;
                            } else {
                                upgrade = !window.full || !window.fullFromSite || organization.created > 1471250000000;
                            }
                        } else {
                            // Stage three - All new users
                            if (!organization) {
                                upgrade = true;
                            } else {
                                upgrade = !window.full || !window.fullFromSite || organization.created > 1472130000000;
                            }
                        }
                    }

                    if (upgrade && numbers['wixmenu.menuview'] < 11) {
                        numbers['wixmenu.menuview'] += 11;
                    }

                    // The following code was the slow upgrade of the new menu settings screen

                    // Data is also regarded as styles for us
                    data = {};

                    if (!(Wix.Utils.getViewMode() !== 'standalone' && Wix.Utils.getViewMode() && _enabled)) {
                        _context18.next = 52;
                        break;
                    }

                    getSetter = function getSetter(key, defaultValue) {
                        var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { isGlobal: false },
                            isGlobal = _ref5.isGlobal;

                        var compKey = key + (isGlobal ? '' : '.' + compId);

                        return (0, _effects.call)(function () {
                            var deferred = _q2.default.defer();

                            // Check if we're in the new or old editor

                            var getData = function getData() {
                                Wix.Data.Public.get(compKey, { scope: 'COMPONENT' }, function () {
                                    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                    try {
                                        data[compKey] = JSON.parse(_lzutf2.default.decompress(response[compKey], { inputEncoding: 'Base64' }));
                                    } catch (e) {
                                        data[compKey] = response[compKey];
                                    }
                                    deferred.resolve();
                                }, function () {
                                    Wix.Data.Public.get(compKey, { scope: 'APP' }, function () {
                                        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                        try {
                                            data[compKey] = JSON.parse(_lzutf2.default.decompress(response[compKey], { inputEncoding: 'Base64' }));
                                        } catch (e) {
                                            data[compKey] = response[compKey];
                                        }
                                        deferred.resolve();
                                    }, function () {
                                        data[compKey] = defaultValue;
                                        deferred.resolve();
                                    });
                                });
                            };

                            if (Wix.Utils.getViewMode() === 'site') {
                                getData();
                            } else {
                                Wix.Features.isSupported(Wix.Features.Types.ADD_COMPONENT, function (supported) {

                                    if (!supported) {
                                        data[compKey] = defaultValue;
                                        deferred.resolve();
                                        return;
                                    }
                                });

                                // Sometimes, Wix.Features.isSupported doesn't work. Currently I've discovered this
                                // happens when opening the external_preview link. So in this case, we always try the
                                // getData. If it'll fail, the isSupported will anyhow return false.
                                _lodash2.default.defer(function () {
                                    return getData();
                                });
                            }

                            return deferred.promise;
                        });
                    };

                    _context18.next = 52;
                    return (0, _effects.all)([getSetter('wixmenu.orderedmenus', { orderedMenus: [] }, { isGlobal: false }), //menu settings - orderedMenus with status
                    getSetter('wixmenu.hiddenlocations', { value: {} }, { isGlobal: false }), getSetter('wixseating.custom.title', { value: null }, { isGlobal: false }), getSetter('wixseating.description', { value: null }, { isGlobal: false }), getSetter('wixseating.custom.button', { value: null }, { isGlobal: false })]);

                case 52:

                    if (_enabled && Wix.Utils.getViewMode() !== 'standalone' && Wix.Utils.getViewMode()) {
                        _lodash2.default.each(colors, function (v, key) {
                            key = key.replace(/wixmenu-/, 'wixmenu.').replace(/wixorders-/, 'wixorder.');

                            // The old editor sometimes sets an object inside an object...
                            if (_lodash2.default.isObject(v)) {
                                v = v.value || v.rgb || v.rgba;
                            }

                            Wix.Styles.setUILIBParamValue('colors', key, { rgba: new _color2.default(v).rgbString(), themeName: key });

                            // Currently Wix's editor UI Lib doesn't handle rgb(r,g,b) syntax well in the color selection
                            // component. This is a workaround to solve it. When bug SE-17673 is fixed, you can remove this.
                            if (_lodash2.default.isString(v) && v.indexOf('rgb(') > -1) {
                                Wix.Styles.setColorParam(key, { value: { rgba: new _color2.default(v).rgbaString() } }, function () {});
                            }
                        });
                    }

                    _context18.next = 55;
                    return (0, _effects.select)(styleSelector);

                case 55:
                    currentStyles = _context18.sent;
                    newStyles = { styles: { colors: colors, fonts: fonts, numbers: numbers, booleans: booleans, data: data, googleFontsCssUrl: googleFontsCssUrl } };

                    if (_lodash2.default.isEqual(currentStyles, newStyles.styles)) {
                        _context18.next = 60;
                        break;
                    }

                    _context18.next = 60;
                    return (0, _effects.put)(StylesActions.actions.setStyles(newStyles));

                case 60:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked, this);
}

var localeSelector = exports.localeSelector = function localeSelector(state) {
    return state.i18n ? state.i18n.i18n.getLocale() : state.i18nData.locale;
};
var styleSelector = exports.styleSelector = function styleSelector(state) {
    return state.styles.styles;
};

// ============================================================================
// DEFAULT SAGA EXPORT
// ============================================================================

function wixStylesSaga(sagaParams) {
    return _regenerator2.default.wrap(function wixStylesSaga$(_context19) {
        while (1) {
            switch (_context19.prev = _context19.next) {
                case 0:
                    _context19.next = 2;
                    return _lodash2.default.map(sagas, function (saga) {
                        return (0, _effects.fork)(saga.bind(null, sagaParams));
                    });

                case 2:
                case 'end':
                    return _context19.stop();
            }
        }
    }, _marked2, this);
}

var DISABLED_STYLES_CONSTS = {
    siteTextPresets: { "Title": { "editorKey": "font_0", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "36px", "fontFamily": "impact", "value": "font:normal normal normal 36px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Menu": { "editorKey": "font_1", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "16px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 16px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Page-title": { "editorKey": "font_2", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "20px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 20px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Heading-XL": { "editorKey": "font_3", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "58px", "fontFamily": "impact", "value": "font:normal normal normal 58px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-L": { "editorKey": "font_4", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "54px", "fontFamily": "impact", "value": "font:normal normal normal 54px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-M": { "editorKey": "font_5", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "36px", "fontFamily": "impact", "value": "font:normal normal normal 36px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-S": { "editorKey": "font_6", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "26px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 26px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-L": { "editorKey": "font_7", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "18px", "fontFamily": "helvetica-w01-bold", "value": "font:normal normal normal 18px/1.4em helvetica-w01-bold,helvetica-w02-bold,helvetica-lt-w10-bold,sans-serif;" }, "Body-M": { "editorKey": "font_8", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "16px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 16px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-S": { "editorKey": "font_9", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "14px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 14px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-XS": { "editorKey": "font_10", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "10px", "fontFamily": "helvetica-w01-light", "value": "font:normal normal normal 10px/1.4em helvetica-w01-light,helvetica-w02-light,sans-serif;" } },
    siteColors: [{ "name": "color_1", "value": "#FFFFFF", "reference": "white/black" }, { "name": "color_2", "value": "#000000", "reference": "black/white" }, { "name": "color_3", "value": "#ED1C24", "reference": "primery-1" }, { "name": "color_4", "value": "#0088CB", "reference": "primery-2" }, { "name": "color_5", "value": "#FFCB05", "reference": "primery-3" }, { "name": "color_11", "value": "#FFFFFF", "reference": "color-1" }, { "name": "color_12", "value": "#CCCCCC", "reference": "color-2" }, { "name": "color_13", "value": "#999999", "reference": "color-3" }, { "name": "color_14", "value": "#535353", "reference": "color-4" }, { "name": "color_15", "value": "#222222", "reference": "color-5" }, { "name": "color_16", "value": "#FFEFBA", "reference": "color-6" }, { "name": "color_17", "value": "#FFE798", "reference": "color-7" }, { "name": "color_18", "value": "#FFCF30", "reference": "color-8" }, { "name": "color_19", "value": "#AA8A20", "reference": "color-9" }, { "name": "color_20", "value": "#554510", "reference": "color-10" }, { "name": "color_21", "value": "#B6E8E3", "reference": "color-11" }, { "name": "color_22", "value": "#8DD1CA", "reference": "color-12" }, { "name": "color_23", "value": "#41BAAE", "reference": "color-13" }, { "name": "color_24", "value": "#2B7C74", "reference": "color-14" }, { "name": "color_25", "value": "#163E3A", "reference": "color-15" }, { "name": "color_26", "value": "#F4C0AF", "reference": "color-16" }, { "name": "color_27", "value": "#E99F86", "reference": "color-17" }, { "name": "color_28", "value": "#DE5021", "reference": "color-18" }, { "name": "color_29", "value": "#943616", "reference": "color-19" }, { "name": "color_30", "value": "#4A1B0B", "reference": "color-20" }, { "name": "color_31", "value": "#FFDAAA", "reference": "color-21" }, { "name": "color_32", "value": "#FFC880", "reference": "color-22" }, { "name": "color_33", "value": "#FF9100", "reference": "color-23" }, { "name": "color_34", "value": "#AA6000", "reference": "color-24" }, { "name": "color_35", "value": "#553000", "reference": "color-25" }],
    styleParams: { fonts: {}, colors: {}, booleans: {}, numbers: {} }
};